import Vue from "vue";
import Vuex from "vuex";

import photos from "./modules/photos.js";
import posts from "./modules/posts.js";
import contact from "./modules/contact.js"
import githubapi from "./modules/github.js"
import mytools from "./modules/mytools.js"
import Visitors from "./modules/detech-visitors.js"
import api from "./modules/api.js"
Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		photos,
		posts,
		contact,
		githubapi,
		mytools,
		Visitors,
		api
	},
});
